import React from "react";
import foto from "../../images/Calendario Cigno 20232024.jpg"
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import locandina from "../../images/Evidenza/Low/Facilitazione.jpg"
import TitoloSezioni from "../../commons/TitoloSezioni";
import "./NewsPagesFoto.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import Spa from "../Spa";
import SpaceL from "../../commons/SpaceL";
import {NavLink} from "react-router-dom";


function Facilitazione () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />
            <div className="container-foto-news m-auto d-none d-sm-block " style={{display: "flex", flexDirection: "column", width: "40%"}}>
                <img src={locandina} style={{width: "100%"}}/>
                <Space />
                <p className="text-center" style={{ fontSize: "22px", fontFamily: "Hammersmith One" }}>
                    <NavLink style={{color: "black"}} to={"https://www.regione.lombardia.it/wps/portal/istituzionale/HP/digitale-facile"}>Maggiori informazioni</NavLink>
                    <br/>
                </p>
            </div>
            <div className="container-foto-news m-auto d-sm-none" style={{display: "flex", flexDirection: "column", width: "80%"}}>
                <img src={locandina} style={{width: "100%"}}/>
                <SpaceL />
            </div>
            <Space />

        </div>
    )
}
export default Facilitazione